module.exports = __webpack_public_path__ + "img/diners.6d7b85d7.png";